module.exports = __webpack_public_path__ + "static/media/xuebi.6564bb01.png";